const PricePolicyEnum = {
  RATE_TYPE: {
    INDUSTRIAL: "industrial",
    RETAIL: "retail"
  },
  SCOPE: {
    GLOBAL: "global",
    SPECIFIC: "specific"
  },
  TYPE: {
    INCREASE: "increase",
    DECREASE: "decrease"
  },
  SHIPPING_TYPE: {
    REVERSE: "reverse",
    NORMAL: "normal"
  }
}
export { PricePolicyEnum }